import { createFileRoute } from "@tanstack/react-router";
import { BucketPage } from "../../../features/bucket/pages/bucket-page";

export const Route = createFileRoute("/$lang/_layout/bucket/")({
  component: BucketPage,
});
